function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ChevronLeftIconSmall, ChevronRightIconSmall } from '@domain-group/fe-co-icon';
import { Button, LinkButton } from '../button/export';
import buildUrl from './util/build-url';
import * as styles from './style/navigation-button.style';
import { boxShadow } from './style/global';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NavigationButton = _ref => {
  var type = _ref.type,
    totalPages = _ref.totalPages,
    currentPage = _ref.currentPage,
    onPageChange = _ref.onPageChange,
    urlTemplate = _ref.urlTemplate,
    baseId = _ref.baseId,
    _ref$hasShadow = _ref.hasShadow,
    hasShadow = _ref$hasShadow === void 0 ? false : _ref$hasShadow;
  var safeCurrentPage = currentPage;
  if (currentPage < 1) {
    safeCurrentPage = 0;
  }
  if (currentPage > totalPages) {
    safeCurrentPage = totalPages + 1;
  }
  var isDisabled = type === 'next' && safeCurrentPage >= totalPages || type === 'prev' && safeCurrentPage <= 1;
  var ChevronSmallIcon = type === 'next' ? ChevronRightIconSmall : ChevronLeftIconSmall;
  var selectedPage = type === 'next' ? safeCurrentPage + 1 : safeCurrentPage - 1;
  var props = {
    appearance: 'outline',
    css: [styles.container, hasShadow && boxShadow],
    disabled: isDisabled,
    id: baseId ? "".concat(baseId, "-paginator-page-").concat(type) : undefined,
    children: [___EmotionJSX("span", {
      css: styles.label,
      key: "sr"
    }, type, " page"), ___EmotionJSX(ChevronSmallIcon, {
      className: "paginator__navigation-icon",
      key: "icon"
    })],
    'data-testid': 'paginator-navigation-button'
  };
  var href = isDisabled ? null : buildUrl(urlTemplate, selectedPage);
  return href ? ___EmotionJSX(LinkButton, _extends({}, props, {
    href: href,
    onClick: event => onPageChange(event, selectedPage, href)
  })) : ___EmotionJSX(Button, props);
};
export default NavigationButton;